import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./OqishniKochirish.module.css";

const OqishniKochirish = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h1 className={classes.title}>
            Talabalar o'qishini ko'chirish va qayta tiklashning umumiy qoidalari
          </h1>
          
          <div className={classes.section}>
            <div className={classes.rulesList}>
              <div className={classes.rule}>
                <span className={classes.ruleNumber}>1.</span>
                <span className={classes.ruleText}>
                  Universitet talabalari o'qishini ko'chirish va qayta tiklashda ta'lim yo'nalishlarining (mutaxassisliklarining) nomlanishi bir xil bo'lganda bunday ta'lim yo'nalishlari (mutaxassisliklari) mos deb hisoblanadi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>2.</span>
                <span className={classes.ruleText}>
                  Talabalar o'qishini ko'chirish yoki qayta tiklash Universitet qabul komissiyasi qarorlari asosida amalga oshiriladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>3.</span>
                <span className={classes.ruleText}>
                  Universitetda oliy ta'limning mos va turdosh yo'nalishlari (ilova qilinadi) hamda mos mutaxassisliklari bo'yicha talabalar o'qishini ko'chirish va qayta tiklash Universitet rektorining buyrug'i asosida amalga oshiriladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>4.</span>
                <span className={classes.ruleText}>
                  Davlat, nodavlat (xususiy) va xorijiy davlatlarning akkreditatsiyaga ega bo'lgan oliy ta'lim muassasalaridan Universitetga talabalar o'qishini ko'chirishga ruxsat etiladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>5.</span>
                <span className={classes.ruleText}>
                  Xorijiy davlatlarning akkreditatsiyaga ega bo'lgan oliy ta'lim muassasalaridan va respublikadagi xususiy oliy ta'lim muassasalaridan Universitetga o'qishini ko'chirishda tegishli ta'lim yo'nalishi (mutaxassisliklarining) ning kirish sinovlariga mos fanlardan test o'tkaziladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>5.</span>
                <span className={classes.ruleText}>
                  Universitetning mos va turdosh bo'lmagan ta'lim yo'nalishlariga ko'chirish o'rnatilgan tartibda, tegishli bakalavriat ta'lim yo'nalishi uchun belgilangan tabaqalashtirilgan to'lov-kontraktning minimal miqdoriga teng bo'lgan bir martalik to'lov asosida amalga oshiriladi.
                </span>
              </div>



              <div className={classes.rule}>
                <span className={classes.ruleNumber}>6.</span>
                <span className={classes.ruleText}>
                  Quyidagi holatlar fuqaroning o'qishini ko'chirish va qayta tiklash haqidagi arizasiga Universitet tomonidan rad javobi berilishiga asos bo'ladi:
                </span>
                <ul className={classes.rejectionList}>
                  <li>Oliy ta'lim muassasalarining markazlari, bo'limlari, o'quv kurslari va boshqalarda o'qiganlarga;</li>
                  <li>birinchi kursning birinchi semestriga birinchi semestr tugallanmagan holatda o'qishni ko'chirishga (talabaga kasallik tufayli akademik ta'til berilgan holatlar, o'qigan ta'lim yo'nalishi mavjud bo'lmaganda ko'chirib tiklash holatlari bundan mustasno);</li>
                  <li>Universitetda mos (yoki turdosh) ta'lim yo'nalishi (mutaxassisligi) yoki ta'lim shakli mavjud bo'lmasa;</li>
                  <li>belgilangan tartibda akkreditatsiyaga ega bo'lmagan muassasada o'qigan bo'lsa;</li>
                  <li>namunaviy o'quv rejalaridagi umumkasbiy va ixtisoslik (mutaxassislik) (majburiy va tanlov) fanlari bo'yicha farqlar 4 tadan oshganda;</li>
                  <li>to'lov-kontrakt asosida o'qishga tavsiya etilganlar to'lovni belgilangan muddatda amalga oshirmaganda;</li>
                  <li>Universitet moddiy-texnika bazasining imkoniyatlari cheklanganligi sababli;</li>
                  <li>xorijiy davlatlar va xususiy oliy ta'lim muassasalaridan Universitetga o'qishini ko'chirishni istaganlar tegishli fanlardan o'tkazilgan test (sinov)dan qoniqarsiz baholanganda;</li>
                  <li>qonunchilikda belgilangan boshqa holatlarda.</li>
                </ul>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>7.</span>
                <span className={classes.ruleText}>
                  Fuqaroning o'qishini ko'chirish (qayta tiklash) bo'yicha arizasiga rad javobi berilgan taqdirda, arizani ko'rib chiqish uchun belgilangan muddatda, arizada ko'rsatilgan manzilga, arizani ko'rib chiqqan komissiya tomonidan javob xati yo'llanadi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>8.</span>
                <span className={classes.ruleText}>
                  Talabalarning o'qishini ko'chirish va qayta tiklashni rasmiylashtirishda Universitet rektori belgilangan tartibda o'quv rejalari va dasturlardagi mavjud akademik qarzlarni yoki farqlarni (namunaviy o'quv rejalaridagi umumkasbiy va ixtisoslik (mutaxassislik) fanlari bo'yicha farqlar 4 tadan oshmasligi lozim) topshirish tartibi va muddatlarini (joriy semestr davomida), o'qitish kursi (semestri) hamda o'qishga qabul qilishning qonunchilikda belgilangan boshqa shartlarini belgilaydi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>9.</span>
                <span className={classes.ruleText}>
                  Qabul komissiyasi tomonidan o'qishini ko'chirish va qayta tiklashga ruxsat etilgan talabaga to'lov-kontrakt shartlari, jumladan, to'lov miqdorlari va muddatlari tushuntiriladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>10.</span>
                <span className={classes.ruleText}>
                  Universitet tomonidan talaba ilgari ta'lim olgan oliy ta'lim muassasasiga uning shaxsiy yig'ma jildini jo'natish uchun so'rovnoma yuboriladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>11.</span>
                <span className={classes.ruleText}>
                  Universitet rektorining talabani belgilangan tartib va muddatda darslarga qatnashishiga ruxsat etish to'g'risidagi buyrug'i u ilgari ta'lim olgan oliy ta'lim muassasasidan uning shaxsiy yig'ma jildi (shaxsiy yig'ma jild jo'natilishi mumkin bo'lmagan hollarda — akademik ma'lumotnomasi) olinib, to'lov-kontrakt shartlari bajarilgandan keyin rasmiylashtiriladi.
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>12.</span>
                <span className={classes.ruleText}>
                  Universitet rektorining to'lov-kontrakt asosida o'qishini ko'chirgan talabalarni o'qishga qabul qilish to'g'risida buyrug'i talaba tomonidan belgilangan muddatda shartnoma to'lovlari amalga oshirilgandan so'ng 10 kun ichida qabul qilinadi.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OqishniKochirish; 